module.exports = __webpack_public_path__ + "img/Charlie Farnsworth.95986d85.png";